import { render, staticRenderFns } from "./InstructionBanner.vue?vue&type=template&id=1141b2b5&scoped=true&"
import script from "./InstructionBanner.vue?vue&type=script&lang=js&"
export * from "./InstructionBanner.vue?vue&type=script&lang=js&"
import style0 from "./InstructionBanner.vue?vue&type=style&index=0&id=1141b2b5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1141b2b5",
  null
  
)

export default component.exports